<div
  class="channel-picker-wrapper"
  *ngIf="channelPickerOptions$ | async as channels"
  i18n-matTooltip="@@Page.ChannelPicker.ChangeCountry.Tooltip"
  matTooltip="Change Country"
  matTooltipClass="accent-200"
>
  <mat-form-field [xAppearance]="appearance">
    <mat-select [formControl]="control" [compareWith]="compareObjects" [disableRipple]="true">
      <mat-select-trigger *ngIf="control.value as val">
        <x-flag-icon [flag]="val.code === 'int' ? val.code : val.defaultCountry"></x-flag-icon>
        <div class="picker-label mat-display-2">{{ val.name }}</div>
      </mat-select-trigger>
      <mat-option *ngFor="let channel of channels; trackBy: 'code' | trackBy" [value]="channel">
        <x-channel-picker-opton [channel]="channel"></x-channel-picker-opton>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
